import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import { SearchBackDrop } from "../component/common/SearchBackDrop";
import KhmWorkerCreatePage from "./create/KhmWorkerCreatePage";
import KhmWorkerPDRCreateListPage from "./create/KhmWorkerPDRCreateListPage";
import KhmWorkerPRCPage from "./prc/KhmWorkerPRCPage";
import KhmWorkerTransPage from  "./trans/KhmWorkerTransPage";
import KhmWorkerISPPage from "./isp/KhmWorkerISPPage";
import KhmWorkerPage from "./KhmWorkerPage"
import KhmInstructionListPage from "./create/KhmInstructionListPage";
import KhmWorkerWikiPage from "./wiki/KhmWorkerWikiPage";


const KhmWorkerRouter = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let union_role = auth.user.roles.some((obj:any) => ['KHM_ISP'].includes(obj.role) && ['Y'].includes(obj.type));

  let trs_role = auth.user.roles.some((obj:any) => ['KHM_TRS'].includes(obj.role));

  let work_pdf = auth.user.roles.some((obj:any) => ['KHM_ISP'].includes(obj.role) && ['PDF'].includes(obj.use_yn));

  return (
    <Box>
      <Routes>
        {/* <Route path="main" element={<MainPage />} /> */}
        {/* {union_role ? 
          <>
            <Route path="/create" element={<KhmInstructionListPage />} /> 
          </>
          : 
          <Route path="/create" element={<KhmWorkerCreatePage />} />
        } */}
        <Route path="/create" element={<KhmWorkerCreatePage />} />
        <Route path="/inst-create" element={<KhmInstructionListPage />} /> 
        {work_pdf &&
          <>
            <Route path="/pdf" element={<KhmWorkerPDRCreateListPage />} />
            <Route path="/wiki" element={<KhmWorkerWikiPage />} /> 
          </>
        }
        <Route path="/prc" element={<KhmWorkerPRCPage />} />
        <Route path="/trans" element={<KhmWorkerTransPage />} />
        <Route path="/isp" element={<KhmWorkerISPPage />} />
        <Route path="*" element={<KhmWorkerPage />} />
      </Routes>
    </Box>
  );
};

export default KhmWorkerRouter;
